const CB_VERSION_TYPE = {
    CB_5_2: { name: 'CB5.2', entity: '5.2' },
    CB_5_5: { name: 'CB5.5', entity: '5.5' },
    CB_6: { name: 'CB6', entity: '6' },
    CB_6_1: { name: 'CB6.1', entity: '6.1' },
    CB_6_1_1: { name: 'CB6.1.1', entity: '6.1.1' },
    CB_6_2: { name: 'CB6.2', entity: '6.2' },
    CB_6_2_1: { name: 'CB6.2.1', entity: '6.2.1' },
    CB_6_2_2: { name: 'CB6.2.2', entity: '6.2.2' },
    CB_6_3_1: { name: 'CB6.3.1', entity: '6.3.1' },
    CB_6_4_1: { name: 'CB6.4.1', entity: '6.4.1' },
    CB_6_5_1: { name: 'CB6.5.1', entity: '6.5.1' }
};

const CB_VERSION_TYPE_SELECT_FILTERS = { ...CB_VERSION_TYPE };
delete CB_VERSION_TYPE_SELECT_FILTERS.OTHER;

export { CB_VERSION_TYPE_SELECT_FILTERS };
export default CB_VERSION_TYPE;